import React, { Suspense } from 'react'
// import React, { Suspense, useContext } from 'react'
import {
  BrowserRouter,
  Route,
  Routes,
  useLocation,
  Navigate,
} from 'react-router-dom'
import { AuthProvider } from '@vt/hooks'
import { User } from '@vt/users'
import { Login } from '@vt/login'
import {
  Areas,
  Standards,
  AppList,
  Share,
  DownloadCenter,
  NotFoundPage,
} from '@vt/comps'
import { Screen } from '@vt/screen'
// import authContext from '@vt/hooks/lib/users/context'

// import { TableBasic, Breadcrumb } from '@vt/comps'

const PageAppOutlet = React.lazy(() => import('@pages-app/Outlet'))
const PageAppTable = React.lazy(() => import('@pages-app/Table'))
const PageAppInspect = React.lazy(() => import('@pages-app/Inspect'))
const PageFooterPrinter = React.lazy(() => import('@pages-app/FooterPrinter'))
const PageAppMatrix = React.lazy(() => import('@pages-app/Matrix'))
const PunchIn = React.lazy(() => import('@pages-app/PunchIn'))
// const Dashboard = React.lazy(() => import('@pages-my'))
// const Login = React.lazy(() => import('@pages-my/login'))

const AuthFailed = function () {
  const location = useLocation()

  return <Navigate to="/login" state={{ from: location }} />
}

// const RequireAuth = function ({ children }) {
//   // const auth = useContext(authContext)
//   const location = useLocation()
//   const { userInfo } = useContext(authContext)

//   if (!Object.keys(userInfo).length) {
//     console.log('没有拿到用户信息')
//     return <Navigate to="/login" state={{ from: location }} />
//   }
//   return children
// }

const RoutesApp = function () {
  return (
    <BrowserRouter>
      <Suspense fallback={<div />}>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            path="/apps/:appId/"
            element={
              <AuthProvider AuthFailedComponent={<AuthFailed />}>
                <PageAppOutlet />
              </AuthProvider>
            }
          >
            <Route path="tbs/:tbId" element={<PageAppTable />} />
            <Route path="tbms/:tbId" element={<PageAppMatrix />} />
            <Route path="inspect/:tbId" element={<PageAppInspect />} />
            <Route path="footPrinter" element={<PageFooterPrinter />} />
            <Route path="users" element={<User />} />
            <Route path="pages/areas" element={<Areas />} />
            <Route path="pages/standards" element={<Standards />} />
            {/* <Route path="pages/app-list" element={<AppList />} /> */}
            <Route path="pages/download-center" element={<DownloadCenter />} />
            <Route path="punchIn" element={<PunchIn />} />
          </Route>
          <Route
            path="app-list"
            element={
              <AuthProvider AuthFailedComponent={<AuthFailed />}>
                <AppList />
              </AuthProvider>
            }
          />
          <Route path="screen/:appId" element={<Screen />} />
          <Route path="share" element={<Share />} />
          <Route path="*" exact element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default RoutesApp
